(function (ws) {
    'use strict';
    ws.views.userSelect = Backbone.View.extend({

        events: {
            'click .usi-icon, .usi-close': 'toggleCart',
            'change .usi-content #country': 'updateAllDropdownValues',
            'change .usi-content #reseller': 'updateCurrency',
            'click .usi-list-link': 'registerAdobeEvent'
        },

        /**
         * Initialize
         */
        initialize: function () {
            this.currencyTemplate = _.template($('#currencyDropdownOptions').html());
            this.$currencyDropdown = this.$('#currency');
            this.countryTemplate = _.template($('#countryDropdownOptions').html());
            this.$countryDropdown = this.$('#country');
            this.accountTemplate = _.template($('#accountDropdownOptions').html());
            this.languageTemplate = _.template($('#languageDropdownOptions').html());
            this.$resellerDropdown = this.$('#reseller');
            this.$languageDropdown = this.$('#language');
            this.$select = this.$('.usi-cart-overlay');
            this.$selectButton = this.$('.usi-list-link');

            this.storeDefaultSelectValues();

            // Close overlay when clicking anywhere outside of it
            $(document).on('click', function(event) {
                const $target = $(event.target);
                const hasClickedOnTheArrow = $target.closest('.usi-icon').length !== 0;
                const hasClickedOutsideBox = !$target.closest('.usi-cart-overlay').length;
                if (!hasClickedOnTheArrow && hasClickedOutsideBox) {
                    this.cleanAllUserOverlayInputs();
                    this.$select.hide();
                }
            }.bind(this));

            // Initialize Drop Down Model
            this.model = new ws.models.userSelectDropdownModel();
            this.currencyModel = new ws.models.userSelectDropdownModel({
                url: globals.path.api.westcon.populateCurrency
            });

            $('#switchUserLanguage').on('click', this.submitUserSelectForm);
            $('#userSelectSubmitAM').on('click', this.submitUserSelectFormOveride);
            $('#userSelectSubmit').on('click', this.submitUserSelectForm);

            this.checkLanguageDropdownStatus();
        },

        /**
         * submitUserSelectForm
         * @param {Object} e
         */
        submitUserSelectForm: function (e) {
            e.preventDefault();
            $('#userSelectForm').submit();
        },

        /**
         * submitUserSelectForm to reseller selection page for Account Managers
         * @param {Object} e
         */
        submitUserSelectFormOveride: function (e) {
            window.location.href = $('#resellersearchRedirect').data('hrefurl');
        },

        /**
         * Store default values user overlay
         */
        storeDefaultSelectValues () {
            this.defaultCurrencyValue = this.$currencyDropdown.html();
            this.defaultCountryValue = this.$countryDropdown.html();
            this.defaultResellerValue = this.$resellerDropdown.html();
            this.defaultLanguageValue = this.$languageDropdown.html();
        },

        /**
         * Set default values for all inputs from user overlay.
         */
        cleanAllUserOverlayInputs: function () {
            this.$countryDropdown.html(this.defaultCountryValue);
            this.$currencyDropdown.html(this.defaultCurrencyValue);
            this.$resellerDropdown.html(this.defaultResellerValue);
            this.$languageDropdown.html(this.defaultLanguageValue);
        },

        /**
         * Toggle Cart
         */
        toggleCart: function () {
            this.cleanAllUserOverlayInputs();
            this.$select.toggle();
        },

        /**
         * Per business rules, when country (sales org) dropdown value is changed, the reseller and currency information will also need to be refreshed.
         */
        updateAllDropdownValues: function () {
            var _this = this;
            this.model.fetch({
                data: {
                    code: this.$countryDropdown.val()
                }
            }).done(function (response) {
                _this.$countryDropdown.html(_this.countryTemplate(response));
                _this.$currencyDropdown.html(_this.currencyTemplate(response));
                _this.$resellerDropdown.html(_this.accountTemplate(response));
                _this.$languageDropdown.html(_this.languageTemplate(response));

                _this.checkLanguageDropdownStatus();
            });
        },

        /**
         * Check language dropdown value to disable or enable
         * If the dropdown doesn't have language
         */
        checkLanguageDropdownStatus: function () {
            if (this.$languageDropdown.has('option').length === 0) {
                this.$selectButton.addClass('disabled');
                this.$selectButton.attr('disabled', 'disabled');
            } else {
                this.$selectButton.removeClass('disabled');
                this.$selectButton.attr('disabled', false);
            }
        },

        /**
         * Update currency dropdown when reseller account is changed.
         */
        updateCurrency: function () {
            var _this = this;
            var selectedReseller = this.$resellerDropdown.val();
            var selectedSalesOrg = this.$countryDropdown.val();
            this.currencyModel.fetch({
                data: {
                    code: selectedSalesOrg,
                    reseller: selectedReseller
                },
                success: function (response) {
                    if (response.error) {
                        console.error(`Server error while updating currency: ${response.error}`);
                        return;
                    }

                    _this.$currencyDropdown.html(_this.currencyTemplate(response.toJSON()));
                },

                error: function (jqXHR, textStatus, errorThrown) {
                    console.error(`Communication error while updating currency: ${textStatus}`, errorThrown);
                }
            });

        },

        /**
        * register adobe user drop down event
         */
        registerAdobeEvent: function () {
            let overlay = $('.usi-cart-overlay');
            dataLayerAA.event = {};
            dataLayerAA.event.currency = overlay.find("[name='currency'] :selected").text().toLowerCase();
            dataLayerAA.event.language = overlay.find("[name='language'] :selected").text().toLowerCase();

            if (dataLayerAA.user.userType !== 'amcustomer') {
                dataLayerAA.event.country = overlay.find("[name='code'] :selected").text().toLowerCase();
                dataLayerAA.event.accountId = overlay.find("[name='userGroupId'] :selected").text().slice(0, 10);
                dataLayerAA.event.accountName = overlay.find("[name='userGroupId'] :selected").text().slice(11).toLowerCase();
                dataLayerAA.event.salesOrg = overlay.find("[name='code'] :selected").val();
            }

            _satellite.track('event:user:dropdown');
        }

    });
})(westcon);

